import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <div className='footer'>
        <h1 className='header-text'>Pups 'N <span className='stroke-text'>Suds</span></h1>
    </div>
  )
}

export default Footer